import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Box, Typography, } from '@mui/material';
import ShopVisitField from './ShopVisitField';
import { useShopVisitActions } from '../hooks/useApiHook';
import { AttachementsUpload } from '../../../shared_elements/components';
import { isValidYearRange } from '../../../utils/helper';
import { PageLoader } from '../../../shared_elements';
import { globalGetService } from '../../../utils/globalApiServices';
import { getEngineLLPApi, getMaintenanceEventApi, getMajorAssemblyApi } from '../apiServices';
import { checkApiStatus } from '../../../utils';
import { assetType } from '../../../constants';
import { setFileUploadDetails } from '../../../shared_elements/actions';
import { formatBytes } from '../../../utils/fileUpload';
import { trackActivity } from '../../../utils/mixpanel';

export const buildEditShopVisit = (data) => {
  if (!data || data.asset_type !== 2 || !Array.isArray(data.events) || data.events.length === 0) return data;
  const maintenance_check = data.events.map((ev) => ({
    id: ev?.maintenance_program?.id,
    name: ev?.maintenance_program?.name,
    is_llp_event: ev?.maintenance_program?.is_llp_event,
    event_id: ev?.id,
    cost: ev?.cost,
  }));
  const modules = {};
  data.events.forEach((ev) => {
    (ev?.modules || []).forEach((mod) => {
      const key = `${mod?.module_name?.toLowerCase()}_event`;
      modules[key] = { id: mod?.id, checked: true, cost: mod?.cost };
    });
  });
  return { ...data, maintenance_check, modules };
};

const ShopVisitCRU = ({ params, modeType, addEditShopVisit,fileUpload, onOpenAttachments, onToggleModal, getResponseBack }) => {
  const dispatch=useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { leaseBasicDetails,storageDetails } = useSelector((state) => state.leases);
  const assetData = leaseBasicDetails?.asset
  const [shopVisit, setShopVisit] = useState(() => (modeType === 'edit' || modeType === 'view') ? buildEditShopVisit(addEditShopVisit?.data) : addEditShopVisit?.data)
  const [pltConstants, setPltConstants] = useState()
  const [llpModuleData, setLlpModuleData] = useState([])
  const [error, setError] = useState({});
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [isLoading, setLoading] = useState({ skeletonLoader: false, pageLoader: false, buttonLoader: false });
  const toggleLoader = (type, status) => { setLoading({ [type]: status }) }
  const [dropdownLoader, setDropdownLoader] = useState({ major_assembly: false, maintenance_check: false, engine_llp: false })
  const toggleDropdownLoader = (type, status) => { setDropdownLoader((prev) => ({ ...prev, [type]: status })) }
  const { saveShopVisit } = useShopVisitActions(params);
  const getMajorAssembly = async () => {
    toggleDropdownLoader("major_assembly", true)
    const response = await globalGetService(getMajorAssemblyApi(params))
    if (response) {
      toggleDropdownLoader("major_assembly", false)
      if (checkApiStatus(response)) {
        const updatedResponse = response?.data?.data?.map(ele => {
        return { ...ele, asset_id: ele.id }
        })
        setPltConstants((prev) => ({ ...prev, asset_types: updatedResponse }))
      }
    }
  }
  const getMaintenanceEvent = async (value) => {
    toggleDropdownLoader("maintenance_check", true)
    const response = await globalGetService(getMaintenanceEventApi(assetType[value?.asset_type], (value?.asset_id || value?.id)))
    if (response) {
      toggleDropdownLoader("maintenance_check", false)
      if (checkApiStatus(response)) {
        const updatedMaintenanceEvents = (response?.data?.data && response?.data?.data[0] && response?.data?.data[0]?.maintenance_events) || []
        setPltConstants((prev) => ({ ...prev, maintenance_events: updatedMaintenanceEvents }))
      }
    }
  }
  const getEngineLLPs = async (assetData) => {
    toggleDropdownLoader("engine_llp", true)
    const response = await globalGetService(getEngineLLPApi("engine", assetData?.slug || assetData?.asset_slug))
    if (response) {
      if (checkApiStatus(response)) {
        toggleDropdownLoader("engine_llp", false)
        const { llp = [], non_llp = [] } = response?.data?.data || {}
        const updatedData = [
          ...llp.map((ele) => ({ label: ele?.name, value: `${ele?.name?.toLowerCase()}_event`, isLlp: true, id: ele?.id })),
          ...non_llp.map((ele) => ({ label: ele?.name, value: `${ele?.name?.toLowerCase()}_event`, isLlp: false, id: ele?.id })),
        ]
        setLlpModuleData(updatedData)
      }
    }
  };

  const effectiveAssetType = assetData?.asset_type === 1 ? shopVisit?.major_assembly?.asset_type : assetData?.asset_type;

  useEffect(() => {
    if (assetData?.asset_type === 1) { getMajorAssembly() }
    if (modeType === "edit" || assetData.asset_type !== 1) { getMaintenanceEvent(assetData.asset_type === 1   ?shopVisit?.major_assembly : assetData    ); }
  }, [assetData])

  useEffect(() => {
    if ((modeType === "edit" || modeType === "view") && effectiveAssetType === 2 && shopVisit?.prsv) {
      getEngineLLPs(assetData?.asset_type === 1 ? shopVisit?.major_assembly : assetData)
    }
  }, [])

  const onFieldChange = (key, value) => {
    const sameMajorAssembly = modeType === "edit" && addEditShopVisit?.data?.major_assembly?.asset_id === value?.asset_id;
    let updatedValues = { [key]: value }

    if (key === "major_assembly") {
      getMaintenanceEvent(value);
      const originalShopVisit = sameMajorAssembly ? buildEditShopVisit(addEditShopVisit?.data) : null;
      updatedValues.prsv = sameMajorAssembly  ? addEditShopVisit?.data?.prsv : false;
      updatedValues.maintenance_check = sameMajorAssembly ? originalShopVisit?.maintenance_check : (value?.asset_type === 2 ? [] : null);
      updatedValues.modules = sameMajorAssembly ? originalShopVisit?.modules : {};
      if (!sameMajorAssembly) { setLlpModuleData([]) }
    }
    if (key === "prsv" && effectiveAssetType === 2) {
      if (value) {
        if (!llpModuleData?.length) {
          getEngineLLPs(assetData?.asset_type === 1 ? shopVisit?.major_assembly : assetData)
        }
      } else {
        setLlpModuleData([])
        updatedValues.modules = {};
      }
    }
    if (key === "maintenance_check" && effectiveAssetType === 2 && !(Array.isArray(value) && value.some((ele) => ele?.is_llp_event === false))) {
      updatedValues.prsv = false;
      updatedValues.modules = {};
      setLlpModuleData([])
    }
    setShopVisit({ ...shopVisit, ...updatedValues });
  }
  const onCheckBoxChange = (module, value) => {
    const key = module?.value
    setShopVisit({ ...shopVisit, modules: { ...shopVisit?.modules, [key]: { ...shopVisit?.modules?.[key], checked: value } } });
  }
  const onAmountChange = (module, amount) => {
    const key = module?.value
    setShopVisit((prev) => ({ ...prev, modules: { ...prev?.modules, [key]: { ...prev?.modules?.[key], cost: amount } } }));
  }
  const onFocusChange = (key) => { setError({ ...error, [key]: "" }) }
  const handleFileChange = (files) => {
       setAttachedFiles(files);
      dispatch(setFileUploadDetails({attachments:files}))
  };

  const onAddEditShopVisit = async () => {
    const effectiveAssetType = assetData?.asset_type === 1 ? shopVisit?.major_assembly?.asset_type : assetData?.asset_type;
    let validationInputs = {};
    validationInputs = {
      shop_visit_end_date: !shopVisit?.shop_visit_end_date ? "Please select Shop Visit End Date" : moment(shopVisit.shop_visit_end_date).isAfter(moment()) ? "Future date is not allowed" : shopVisit.shop_visit_start_date && moment(shopVisit.shop_visit_end_date).isBefore(moment(shopVisit.shop_visit_start_date)) ? "Shop Visit End date must be after Shop Visit Start Date" : !isValidYearRange(shopVisit?.shop_visit_end_date) ? "Year must be between 1900 and 2100." : "",
      csn: effectiveAssetType === 5 ? "" : shopVisit?.csn === 0 ? "" : !shopVisit?.csn ? "Please enter CSN @ Shop Visit" : "",
      tsn: effectiveAssetType === 4 ? "" : shopVisit?.tsn === 0 ? "" : !shopVisit?.tsn ? "Please enter TSN @ Shop Visit" : "",
      maintenance_check: (Array.isArray(shopVisit?.maintenance_check) ? shopVisit.maintenance_check.length === 0 : !shopVisit?.maintenance_check) ? "Please select Shop Visit For" : "",
      major_assembly: assetData?.asset_type === 1 && !shopVisit?.major_assembly?.asset_slug ? "Please select Assembly" : "",
      removal_reason:  shopVisit?.removal_reason?.length > 0 ? '' : 'Please enter Reason for Shop Visit',
    };
  
     if (shopVisit.shop_visit_start_date && moment(leaseBasicDetails.start_date).isAfter(moment(shopVisit.shop_visit_start_date))) {
      return enqueueSnackbar(`Shop Visit Start date : Must be between lease start and end dates.`, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
    }
    else if (shopVisit.shop_visit_start_date && moment(leaseBasicDetails.end_date).isBefore(moment(shopVisit.shop_visit_start_date))) {
      return enqueueSnackbar(`Shop Visit Start date : Must be between lease start and end dates.`, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
    }
    else if (shopVisit.shop_visit_end_date && moment(leaseBasicDetails.end_date).isBefore(moment(shopVisit.shop_visit_end_date))) {
      return enqueueSnackbar(`Shop Visit End date : Must be between lease start and end dates.`, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
    } 
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      let updatedPayload = {
        csn: Number(shopVisit?.csn)|| 0,
        tsn: Number(shopVisit?.tsn) || 0,
        cost: Number(shopVisit?.cost) ||0 ,
        prsv: !!shopVisit?.prsv,
      }
      if (effectiveAssetType === 2) {
        const modules = llpModuleData?.length > 0 ? llpModuleData.filter(module =>
          Boolean(shopVisit?.modules?.[module.value]?.checked)
        ).map(module => {
          const moduleEntry = shopVisit?.modules?.[module.value];
          return {
            ...(modeType === 'edit' && moduleEntry?.id ? { id: moduleEntry.id } : {}),
            limited_life_part_id: module?.id ?? null,
            module_name: module?.label,
            is_non_llp: !module?.isLlp,
            cost: Number(moduleEntry?.cost) || 0,
          };
        }) : [];
        const maintenanceChecks = Array.isArray(shopVisit?.maintenance_check) ? shopVisit.maintenance_check : (shopVisit?.maintenance_check ? [shopVisit.maintenance_check] : []);
        const modulesCost = modules.reduce((sum, module) => sum + (Number(module?.cost) || 0), 0);
        const llpEventsCost = maintenanceChecks.reduce((sum, check) => check?.is_llp_event === true ? sum + (Number(check?.cost) || 0) : sum, 0);
        const svCost = Number(shopVisit?.cost) || 0;
        const hasPrsv = modules.length > 0;
        const hasLlp = maintenanceChecks.some(check => check?.is_llp_event === true);
        if (modulesCost > svCost || llpEventsCost > svCost || (modulesCost + llpEventsCost) > svCost) {
          const parts = [];
          if (hasPrsv) parts.push(`PRSV: ${modulesCost}`);
          if (hasLlp) parts.push(`LLP: ${llpEventsCost}`);
          if (hasPrsv && hasLlp) parts.push(`Total: ${modulesCost + llpEventsCost}`);
          parts.push(`Max: ${svCost}`);
          enqueueSnackbar(`Cost exceeds shop visit limit (${parts.join(', ')}).`, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
          return;
        }
        updatedPayload.events = maintenanceChecks.map(check => ({
          ...(modeType === 'edit' && check?.event_id ? { id: check.event_id } : {}),
          maintenance_program_id: check?.id,
          cost: check?.is_llp_event === true ? (Number(check?.cost) || 0) : modulesCost,
          modules: check?.is_llp_event === true ? [] : modules,
        }));
      } else {
        updatedPayload.maintenance_check_id = shopVisit?.maintenance_check ? shopVisit?.maintenance_check?.id : null;
      }
      if ([1,2,3,4,5].includes(shopVisit?.major_assembly?.asset_type)) {
        updatedPayload = {
          ...shopVisit,
          ...updatedPayload,
          is_stand_alone: false,
          major_assembly: shopVisit?.major_assembly
        };
      } else { 
        updatedPayload = {
          ...shopVisit,
          ...updatedPayload,
          asset_type: assetData?.asset_type,
          asset_id: assetData?.id,
          is_stand_alone: true,
          major_assembly:null
        };
      }
      if (effectiveAssetType === 2) {
        delete updatedPayload.modules;
        delete updatedPayload.maintenance_check;
        delete updatedPayload.maintenance_check_id;
      }
      const response = await saveShopVisit(assetData, shopVisit, updatedPayload, toggleLoader);
      if (response) {
        if (attachedFiles?.length > 0) { if (response?.slug) { fileUpload(response?.slug, shopVisit?.id?'updated':'created'); } }
        onToggleModal();
        getResponseBack();
      }
    } else {
      setError(validationInputs);
      trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Shop Visit`, error_msg: validationInputs, })
    }
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Shop Visit`, page_type: page_type, })
  }
  return (
    <>
      <Dialog
        aria-labelledby="customized-dialog-title"
        className='add-lease-dialog'
        maxWidth='md'
        fullWidth
        open={addEditShopVisit?.modal}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
          <Typography sx={{marginLeft: "10px"}}>
            {modeType === 'add' ? 'Add Shop Visit' : modeType === 'edit' ? 'Edit Shop Visit' : 'View Shop Visit'}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <ShopVisitField assetData={assetData} modeType={modeType} dropdownLoader={dropdownLoader} pltConstants={pltConstants} llpModuleData={llpModuleData} shopVisit={shopVisit} onFieldChange={onFieldChange} onCheckBoxChange={onCheckBoxChange} onAmountChange={onAmountChange} onFocusChange={onFocusChange} error={error} isLoading={isLoading} />
          <Grid size={{ md: 12, xs: 12 }} sx={effectiveAssetType === 2  ? {mt:1} : undefined}>
             <Box sx={{display:"flex",justifyContent:"space-between"}} >
            
            {shopVisit?.id && addEditShopVisit?.data?.attachments?.length ?
              <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({addEditShopVisit?.data?.attachments?.length})Attachment(s)</Button> : null
            }
             <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
            </Box>
            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={addEditShopVisit?.data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <Button className='cancel-btn' variant='outlined' size='small' disabled={isLoading?.buttonLoader} onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Cancel </Button>
          <Button variant='contained' className='btn-primary' disabled={modeType === 'view' || dropdownLoader?.engine_llp || isLoading?.buttonLoader} size='small' onClick={() => { handleItemClicked('Save Button'); onAddEditShopVisit() }}>
            {isLoading?.buttonLoader ? <CircularProgress color='inherit' size={25} /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
      {isLoading?.pageLoader ? <PageLoader /> : null}
    </>
  )
}

export default ShopVisitCRU